// AS-19644 | Hack for Google Translate
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
// fixme: remove a hack after root issue fixed
/* eslint-disable func-names, prefer-rest-params */
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        // fixme: this hack conflicts with CRM Chat - so we will skip it's elements
        if (child.parentNode !== this && (!child.hasAttribute || !child.hasAttribute('lightning-primitiveIcon_primitiveIcon'))) {
            if (console) {
                console.error('Cannot remove a child from a different parent', child, this);
            }
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
                console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
            }
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
}
